// AI Action type system — extensible action types for AI panel suggestions

export interface AiAction {
  type: string;       // 'field-changes' | 'image-tags' | 'search' | ...
  title: string;
  description?: string;
}

export interface FieldChange {
  field: string;        // field key
  fieldLabel: string;   // human-readable label
  oldValue: string;
  newValue: string;
  reasoning?: string;
  selected: boolean;    // user can toggle
}

export interface FieldChangesAction extends AiAction {
  type: 'field-changes';
  changes: FieldChange[];
}

/**
 * Parse <actions>...</actions> blocks from AI response text.
 * Returns { text, actions } where text has the block removed.
 */
export function parseActionsFromText(raw: string): { text: string; actions: AiAction[] } {
  const regex = /<actions>\s*([\s\S]*?)\s*<\/actions>/gi;
  let actions: AiAction[] = [];
  const text = raw.replace(regex, (_: string, jsonStr: string) => {
    try {
      const parsed = JSON.parse(jsonStr);
      if (Array.isArray(parsed)) {
        for (const action of parsed) {
          if (action.type === 'field-changes' && Array.isArray(action.changes)) {
            for (const change of action.changes) {
              if (change.selected === undefined) {
                change.selected = true;
              }
            }
          }
        }
        actions = [...actions, ...parsed];
      }
    } catch (e) {
      console.warn('Failed to parse AI actions JSON:', e);
    }
    return '';
  }).trim();

  return { text, actions };
}
